import { compose } from 'redux';
import { connect } from 'react-redux';

import routeDependencies from 'utilities/routeDependencies';
import { loadable } from 'modules/layout';

import ImageMapsPage from '../components/ImageMapsPage';

import { selectListPending } from '../services/selectors';
import { imageMapsRequest } from '../services/actions';

export default compose(
    connect(
        state => ({
            showLoader: selectListPending(state),
        }),
        dispatch => ({
            read: () => {
                dispatch(imageMapsRequest());
            },
        }),
    ),
    routeDependencies(),
    loadable,
)(ImageMapsPage);
